import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { SnackBarErrorComponent } from './snack-bar-error.component';

@NgModule({
  declarations: [
    SnackBarErrorComponent
  ],
  imports: [
    CommonModule,
    MatButtonModule,
    MatIconModule,
    MatSnackBarModule
  ],
  exports: [
    SnackBarErrorComponent
  ]
})
export class SnackBarErrorModule { }
